// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import QuestionnairController from "./questionnair_controller"
application.register("questionnair", QuestionnairController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import StatisticsController from "./statistics_controller"
application.register("statistics", StatisticsController)

import StatusController from "./status_controller"
application.register("status", StatusController)
